<ng-container *ngIf="isStep('insertion-list')">
  <rt-redactor-inserts-dropdown-item
    [iconName]="'mail'"
    [selected]="selected"
    [heading]="'app.redactor_inserts.email_templates.dropdown.heading' | translate"
    [subheading]="'app.redactor_inserts.email_templates.dropdown.subheading' | translate"
    [link]="'settings/emails'"
    (stepInside)="goSecondStep()"
  >
  </rt-redactor-inserts-dropdown-item>
</ng-container>

<ng-container
  *ngIf="isStep(InsertsEmailKind.EmailTemplate) || isStep(InsertsEmailKind.EventInvitation)"
>
  <div (keydown)="handleKeyDown($event)" tabindex="0">
    <rt-redactor-inserts-dropdown-header
      [hasBackAction]="hasBackAction"
      [hasSearch]="state.emailTemplates.length > 5"
      [hasSettings]="true"
      [searchQuery]="state.searchQuery"
      [searchPlaceholder]="'app.common.placeholders.search.email_templates.other' | translate"
      [label]="'app.redactor_inserts.email_templates.dropdown.heading' | translate"
      (focusChanges)="onFocusChanges($event)"
      (searchQueryChange)="onSearchQueryChange($event)"
      (goBack)="goBack()"
      (goToSettings)="goToPage('settings/emails')"
      (closeDropdown)="closeDropdown.emit()"
    >
    </rt-redactor-inserts-dropdown-header>
    <ng-container *ngIf="!insideTemplate">
      <ng-container *ngIf="state.emailTemplateGroups.length > 0">
        <div class="group-container">
          <div
            *ngFor="let emailTemplateGroup of state.emailTemplateGroups; trackBy: groupsTrackByFn"
          >
            <rt-dropdown-header [isSubheading]="true">
              {{ emailTemplateGroup.groupName }}
            </rt-dropdown-header>

            <rt-dropdown-item
              *ngFor="
                let template of emailTemplateGroup.groupedEmailTemplates;
                trackBy: templatesTrackByFn;
                let index = index
              "
              #eleRef
              [highlighted]="state.selectedId === template.id"
              (click)="emailTemplateChoose.emit(template)"
              [attr.data-id]="template.id"
            >
              {{ template.title }}
            </rt-dropdown-item>
          </div>
        </div>
        <rt-divider></rt-divider>
        <rt-dropdown-item
          *ngIf="InsertsEmailKind.EventInvitation === kind"
          [noDivider]="true"
          (click)="saveAsTemplate.emit()"
        >
          <rt-icon prefix name="playlist-add"></rt-icon>
          {{ 'app.email_templates.event_invitation_inserts.save_as_template' | translate }}
        </rt-dropdown-item>
      </ng-container>

      <ng-container *ngIf="state.emailTemplates.length === 0">
        <rt-empty-state
          [title]="'app.redactor_inserts.email_templates.dropdown.empty_state_title' | translate"
          [desc]="'app.redactor_inserts.email_templates.dropdown.empty_state_desc' | translate"
          variant="small"
          class="empty-state"
          padding-lr
        >
          <rt-button (click)="goToPage('settings/emails')" variant="primary">
            {{ 'app.redactor_inserts.email_templates.dropdown.manage_templates' | translate }}
          </rt-button>
        </rt-empty-state>
      </ng-container>

      <ng-container
        *ngIf="state.emailTemplateGroups.length === 0 && state.emailTemplates.length !== 0"
      >
        <rt-empty-state
          [title]="'app.redactor_inserts.email_templates.dropdown.no_filtered_title' | translate"
          [desc]="'app.redactor_inserts.email_templates.dropdown.no_filtered_desc' | translate"
          variant="small"
          class="empty-state"
          padding-lr
        >
        </rt-empty-state>
      </ng-container>
    </ng-container>

    <ng-container *ngIf="insideTemplate">
      <ng-container *ngTemplateOutlet="insideTemplate"> </ng-container>
    </ng-container>
  </div>
</ng-container>
